import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// Views
import Dashboard from '@/views/Dashboard'
import Competitions from '@/views/Competitions'
import CreateCompetition from '@/views/CreateCompetition'
import GlobalSettings from '@/views/GlobalSettings'
import Moderation from '@/views/Moderation'
import Reporting from '@/views/Reporting'

// Subviews
import ManageCompetitions from '@/views/ManageCompetitions'
import EditCompetition from '@/views/EditCompetition'

Vue.use(VueRouter)

/**
 * Middleware
 */

// Log user out if they visit this route
async function logOut(to, from, next) {
	await store.dispatch('auth/logOut')
	next('/')
}

function handleAuth(to, from, next) {
	const loggedIn = store.getters['auth/loggedIn']

	if (loggedIn && to.path === '/') {
		return next({ name: 'Dashboard' })
	} else if (!loggedIn && to.path !== '/') {
		return next('/')
	}
	next()
}

/**
 * Routes
 */

const routes = [
	{
		path: '/',
		name: 'Home',
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
	},
	{
		path: '/competitions',
		component: Competitions,
		children: [
			{
				path: '',
				name: 'Manage Competitions',
				component: ManageCompetitions,
			},
			{
				path: ':id',
				name: 'Edit Competition',
				component: EditCompetition,
			},
		],
	},
	{
		path: '/create',
		name: 'Create Competition',
		component: CreateCompetition,
	},
	{
		path: '/settings',
		name: 'Global Settings',
		component: GlobalSettings,
	},
	{
		path: '/moderation',
		name: 'Moderation',
		component: Moderation,
	},
	{
		path: '/reporting',
		name: 'Reporting',
		component: Reporting,
	},
	{
		path: '/logout',
		name: 'Log Out',
		beforeEnter: logOut,
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

router.beforeEach(handleAuth)

export default router
